<template>
  <generic-view
    :title="$t('log in configuration')"
    icon="sign in"
    v-bind:searchable="false"
    v-bind:configurable="false"
    ref="login_component"
  >
    <div class="ui form">
      <h3 class="ui dividing header">{{ $t("enterprise") }}</h3>
      <div class="two fields">
        <div class="field">
          <label for="">{{ $t("default enterprise") }}</label>
          <div class="ui selection dropdown" ref="enterprise_dropdown">
            <input type="hidden" name="ddwn" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field">
          <label for="">{{ $t("enterprise field") }}</label>
          <div class="ui toggle checkbox">
            <input
              type="checkbox"
              name="public"
              v-model="config.hide_enterprise_field"
            />
            <label>{{ $t("hide enterprise field") }}</label>
          </div>
        </div>
      </div>
      <div class="field">
        <label for="">{{ $t("logo") }}</label>
        <file-pond
          name="file"
          ref="pond"
          :label-idle="$t('click or drop files here')"
          v-bind:allow-multiple="false"
          v-bind:allow-revert="false"
          v-bind:server="{
            url: api_host,
            timeout: enterprise_setup.upload_timeout,
            process: {
              url: '/system/do-upload-image',
              method: 'POST',
              chunkUploads: true,
              headers: {
                'x-access-token': token_session,
              },
              withCredentials: false,
            },
          }"
          v-on:error="filepond_error"
          v-on:processfile="filepond_process"
        />
        <img
          class="ui medium rounded image"
          v-if="config.logo"
          :src="resource_url(config.logo)"
        />
        <div class="ui orange icon labeled button" @click="clear_logo">
          <i class="remove icon"></i> {{ $t("clear logo") }}
        </div>
      </div>

      <h3 class="ui dividing header">{{ $t("security") }}</h3>
      <div class="two fields">
        <div class="field">
          <label for="">{{ $t("jwt key") }}</label>
          <input type="text" name="jwt_key" v-model="config.jwt_key" />
        </div>
        <div class="field">
          <label for="">{{ $t("validity time") }}</label>
          <input
            type="text"
            name="jwt_validity_time"
            v-model="config.jwt_validity_time"
          />
        </div>
      </div>

      <h3 class="ui dividing header">{{ $t("system") }}</h3>
      <div class="fields">
        <div class="three wide field">
          <label for="">{{ $t("protocol") }}</label>
          <select
            name="protocol"
            v-model="config.protocol"
            class="ui selection dropdown"
            ref="protocol_dropdown"
          >
            <option value="">{{ $t("select one") }}</option>
            <option value="http">{{ $t("http") }}</option>
            <option value="https">{{ $t("https") }}</option>
          </select>
        </div>
        <div class="nine wide field">
          <label for="">{{ $t("domain") }}</label>
          <input type="text" name="domain" v-model="config.domain" />
        </div>
        <div class="four wide field">
          <label for="">{{ $t("restart command") }}</label>
          <input
            type="text"
            name="restart_command"
            v-model="config.restart_command"
          />
        </div>
      </div>

      <div class="ui blue icon labeled button" @click="save">
        <i class="save icon"></i> {{ $t("save") }}
      </div>
      <div class="ui red icon labeled button" @click="restart">
        <i class="power off icon"></i> {{ $t("restart") }}
      </div>
    </div>
  </generic-view>
</template>

<script>
import {
  local_api,
  error_toast,
  success_toast,
  enterprise_setup,
  api_host,
} from "@/utils";
import GenericView from "@/components/GenericContainer";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";

const FilePond = vueFilePond();

export default {
  name: "SettingsLoginManagement",
  data() {
    return {
      processing: false,
      config: {},
      enterprises: [],
      api_host: api_host,
    };
  },
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  components: {
    "generic-view": GenericView,
    FilePond,
  },
  watch: {},
  methods: {
    getData() {
      let vm = this;
      local_api(this, "post", "/system/do-get-login-config", {})
        .then((response) => {
          vm.enterprises = response.enterprises;
          if (response.config) this.config = JSON.parse(response.config);
          else
            this.config = {
              hide_enterprise_field: false,
              default_enterprise: "",
              logo: "",
            };

          let vls = response.enterprises.map((e) => {
            return { name: e.name, value: e.codename };
          });
          window
            .jQuery(vm.$refs.enterprise_dropdown)
            .dropdown("setup menu", { values: vls })
            .dropdown({
              onChange(value) {
                vm.config.default_enterprise = value;
              },
            });

          if (this.config.default_enterprise) {
            window
              .jQuery(vm.$refs.enterprise_dropdown)
              .dropdown("set selected", this.config.default_enterprise);
          }
          // console.log(this.config);
          if (this.config.protocol) {
            window
              .jQuery(vm.$refs.protocol_dropdown)
              .dropdown("set selected", this.config.protocol);
          }

          // if (this.config.logo) {
          //   console.log(this.config.logo);
          // }
        })
        .catch((err) => {
          error_toast(err);
        })
        .finally(() => {
          vm.processing = false;
        });
    },
    save() {
      let vm = this;
      local_api(vm, "post", "/system/do-save-login-config", {
        config: JSON.stringify(vm.config, null, 2),
      })
        .then(() => {
          success_toast(vm.$t("log in configuration set"));
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    filepond_error(a, b) {
      console.log("error", a, b);
    },
    filepond_process(event, inst) {
      let vm = this;
      if (inst && inst.serverId) {
        let parsed = JSON.parse(inst.serverId);
        // console.log(parsed);
        if (!parsed.success) {
          let x1 = vm.$refs.pond;
          // console.log(parsed.error);
          x1.removeFiles().then((/* r */) => {
            // console.log(r);
          });
        } else {
          vm.config.logo = parsed.data;
        }
      }
    },
    resource_url(file_name) {
      return `${api_host}/public/uploads/logo/${file_name}`;
    },
    clear_logo() {
      this.config.logo = "";
    },
    restart() {
      let vm = this;
      local_api(vm, "post", "/system/do-restart", {})
        .then(() => {
          success_toast(vm.$t("restarting system"));
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {
    let vm = this;
    vm.getData();
    window.jQuery(vm.$refs.protocol_dropdown).dropdown();
  },
};
</script>

<style scoped></style>
